'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _actions = require('./actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActivateMapPin = function (_React$Component) {
  (0, _inherits3.default)(ActivateMapPin, _React$Component);

  function ActivateMapPin(props) {
    (0, _classCallCheck3.default)(this, ActivateMapPin);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ActivateMapPin.__proto__ || (0, _getPrototypeOf2.default)(ActivateMapPin)).call(this, props));

    _this.setRef = _this.setRef.bind(_this);
    _this.activatePin = _this.activatePin.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ActivateMapPin, [{
    key: 'setRef',
    value: function setRef(node) {
      var event = this.props.hover ? 'mouseenter' : 'click';

      if (this.ref) {
        this.ref.removeEventListener(event, this.activatePin);
      }
      if (node) {
        this.ref = node;
        this.ref.addEventListener(event, this.activatePin);
      }
    }
  }, {
    key: 'activatePin',
    value: function activatePin(e) {
      e.preventDefault();
      var _props = this.props,
          itemId = _props.itemId,
          setActive = _props.setActive;


      setActive(itemId);
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      return _react2.default.createElement(
        'div',
        { ref: this.setRef },
        children
      );
    }
  }]);
  return ActivateMapPin;
}(_react2.default.Component);

ActivateMapPin.propTypes = {
  hover: _propTypes2.default.bool,
  itemId: _propTypes2.default.string.isRequired,
  setActive: _propTypes2.default.func.isRequired,
  children: _propTypes2.default.node
};
ActivateMapPin.defaultProps = {
  hover: false,
  children: null
};

function mapDispatchToProps(dispatch) {
  return {
    setActive: function setActive(id) {
      return dispatch((0, _actions.setActivePinId)(id));
    }
  };
}

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(ActivateMapPin);


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/Map/ActivateMapPin.js
// module id = 993
// module chunks = 0